export type GuideTourDismissalRecord = {
  tourId: string
  version: number
  pathname: string
  /** When false, dismissal does not block auto-start (overlay was not fully shown). */
  gatesReady: boolean
}

export const isGuideTourDismissedOnPath = (
  dismissal: GuideTourDismissalRecord | null,
  tourId: string,
  version: number,
  pathname: string
): boolean => {
  if (!dismissal) {
    return false
  }

  return (
    dismissal.gatesReady &&
    dismissal.tourId === tourId &&
    dismissal.version === version &&
    dismissal.pathname === pathname
  )
}

export const clearGuideTourDismissalOutsidePath = (
  dismissal: GuideTourDismissalRecord | null,
  pathname: string
): GuideTourDismissalRecord | null => {
  if (!dismissal || dismissal.pathname === pathname) {
    return dismissal
  }

  return null
}

export const clearGuideTourDismissalForTour = (
  dismissal: GuideTourDismissalRecord | null,
  tourId: string,
  version: number
): GuideTourDismissalRecord | null => {
  if (dismissal?.tourId === tourId && dismissal.version === version) {
    return null
  }

  return dismissal
}
